// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"31e7a5fd","390":"f2bb15da","759":"44f79b23","787":"e3e97396","911":"faf2ac4d"}[chunkId] + ".chunk.js";
};